export default __webpack_public_path__ + "static/media/nike.7ecd931e.jpg";